import {BookingExtra} from "../../../types";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {RootState} from "../../../store";
import {Fragment, useState} from "react";
import FormSectionTitle from "../../form/FormSectionTitle";
import BaseTable from "../../data/BaseTable";
import {formatCurrency} from "../../../shared/utils";

export default function BookingExtraService ({
   idBooking,
   extras,
   onRefetch
} : {
    onRefetch?: () => void,
    idBooking: string,
    extras: BookingExtra[]
}) {

    const { t } = useTranslation()

    return (
        <Fragment>
            <FormSectionTitle
                dense={true}
                borderless={true}
                title={t('reservation.extraServices')}
                subtitle={t('reservation.extraServicesText')}
                edit={false}
            />

            <BaseTable
                showFilters={false}
                showColumnSelector={false}
                data={extras}
                filterable={false}
                paginated={false}
                identifierKey={'idBookingGuest'}
                columns={[
                    {
                        Header: t('reservation.extraId').toString(),
                        accessor: (row: any) => {
                            return row.id
                        }
                    },
                    {
                        Header: t('reservation.serviceName').toString(),
                        accessor: (row: any) => {
                            return row.description
                        }
                    },
                    {
                        Header: t('reservation.servicePrice').toString(),
                        accessor: (row: any) => {
                            return formatCurrency(row.price)
                        }
                    },
                    {
                        Header: t('reservation.serviceQuantity').toString(),
                        accessor: (row: any) => {
                            return row.quantity
                        }
                    }
                ]} />
        </Fragment>
    )

}
